import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { TotemHomeComponent } from './routes/totem-home/totem-home.component';
import { TotemCustomerCareBookComponent } from './routes/totem-customer-care-book/totem-customer-care-book.component';
import { TotemCustomerCareCallComponent } from './routes/totem-customer-care-call/totem-customer-care-call.component';

const routes: Routes = [{
    path: 'customer-care/:id',
    component: TotemCustomerCareCallComponent
}, {
    path: 'book-customer-care',
    component: TotemCustomerCareBookComponent
}, {
    path: '',
    pathMatch: 'full',
    component: TotemHomeComponent
}, {
    path: '**',
    redirectTo: ''
}];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
